/**
 * Product Swatch Groups: handles the Grouped/All Colors toggle
 * and the color-group tab switching inside the color swatch picker.
 * Uses event delegation so it survives Section Rendering API morphs
 * without needing re-initialization.
 */
(function () {
  function getFieldset(el) {
    return el.closest('fieldset[id^="ColorSwatches-"]');
  }


  (function injectSwatchStyles() {
    if (document.getElementById('swatch-group-style')) return;
    const style = document.createElement('style');
    style.id = 'swatch-group-style';
    style.textContent = `
        .product-swatch__wrapper [data-title].swatch-group-hidden {
        display: none !important;
        }
        .product-swatch__wrapper [data-title].swatch-group-visible {
        display: flex !important;
        }
    `;
    document.head.appendChild(style);
    })();

  function getGroupData(fieldset) {
    if (fieldset._swatchGroupData) return fieldset._swatchGroupData;
    const script = fieldset.querySelector('[data-color-group-map]');
    if (!script) return {};
    try {
      const data = JSON.parse(script.textContent);
      fieldset._swatchGroupData = data;
      return data;
    } catch (err) {
      console.error('Swatch group JSON parse failed:', err);
      return {};
    }
  }

  function filterSwatchesByColors(fieldset, colorHandles) {
    const wrapper = fieldset.querySelector('.product-swatch__wrapper');
    if (!wrapper) return;
    wrapper.querySelectorAll('[data-title]').forEach((swatch) => {
        const title = swatch.getAttribute('data-title');
        const shouldShow = colorHandles.includes(title);
        swatch.classList.toggle('swatch-group-hidden', !shouldShow);
        swatch.classList.toggle('swatch-group-visible', shouldShow);
    });
    }

    function showAllSwatches(fieldset) {
        const wrapper = fieldset.querySelector('.product-swatch__wrapper');
        if (!wrapper) return;
        wrapper.querySelectorAll('[data-title]').forEach((swatch) => {
            swatch.classList.remove('swatch-group-hidden');
            swatch.classList.add('swatch-group-visible');
        });
    }

  function updateToneInfo(fieldset, toneArray) {
    const infoBox = fieldset.querySelector('[data-swatch-tone-info]');
    if (!infoBox) return;

    if (!toneArray || !toneArray.length) {
      infoBox.style.display = 'none';
      return;
    }

    const list = infoBox.querySelector('.product-swatch__info-list');
    if (!list) return;

    list.innerHTML = toneArray
      .map((tone) => {
        if (typeof tone !== 'string') return '';
        const parts = tone.split(':');
        const term = (parts[0] || '').trim();
        const desc = (parts[1] || '').trim();
        return (
          '<li class="product-swatch__info-row">' +
            '<div class="product-swatch__info-term"><span>' + term + '</span></div>' +
            '<div class="product-swatch__info-desc"><span>' + desc + '</span></div>' +
          '</li>'
        );
      })
      .join('');

    infoBox.style.display = '';
  }

  function setActiveTab(tabsContainer, activeBtn) {
    tabsContainer.querySelectorAll('[data-swatch-group]').forEach((btn) => {
      const isActive = btn === activeBtn;
      btn.classList.toggle('product-swatch__option--selected', isActive);
      btn.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });
  }

  function applyTab(fieldset, tabBtn) {
    const tabsContainer = tabBtn.closest('[data-swatch-tabs]');
    const groupHandle = tabBtn.getAttribute('data-swatch-group');
    const groupMap = getGroupData(fieldset);
    const group = groupMap[groupHandle];
    if (!group) return;

    setActiveTab(tabsContainer, tabBtn);
    filterSwatchesByColors(fieldset, group.colors || []);
    updateToneInfo(fieldset, group.tone || []);
    fieldset.dataset.activeGroup = groupHandle;
  }

  function handleTabClick(tabBtn) {
    const fieldset = getFieldset(tabBtn);
    if (!fieldset) return;
    applyTab(fieldset, tabBtn);
  }

  function handleViewToggle(viewBtn) {
    const fieldset = getFieldset(viewBtn);
    if (!fieldset) return;

    const toggleContainer = viewBtn.closest('[data-swatch-view-toggle]');
    if (!toggleContainer) return;
    const view = viewBtn.getAttribute('data-swatch-view'); // 'grouped' | 'all'
    const tabsContainer = fieldset.querySelector('[data-swatch-tabs]');
    const infoBox = fieldset.querySelector('[data-swatch-tone-info]');

    toggleContainer.querySelectorAll('[data-swatch-view]').forEach((btn) => {
      btn.classList.toggle('product-swatch__view-option--active', btn === viewBtn);
    });

    fieldset.dataset.activeView = view;

    if (view === 'all') {
      if (tabsContainer) tabsContainer.style.display = 'none';
      if (infoBox) infoBox.style.display = 'none';
      showAllSwatches(fieldset);
      return;
    }

    // Switching back to "grouped": restore tabs and re-apply
    // whichever tab was last active (fall back to the first tab,
    // which Liquid already marks as selected on page load)
    if (tabsContainer) {
      tabsContainer.style.display = '';
      const activeBtn =
        tabsContainer.querySelector('[data-swatch-group].product-swatch__option--selected') ||
        tabsContainer.querySelector('[data-swatch-group]');
      if (activeBtn) applyTab(fieldset, activeBtn);
    }
  }

  document.addEventListener('click', function (event) {
    const viewBtn = event.target.closest('[data-swatch-view]');
    if (viewBtn) {
      handleViewToggle(viewBtn);
      return;
    }

    const tabBtn = event.target.closest('[data-swatch-tabs] [data-swatch-group]');
    if (tabBtn) {
      handleTabClick(tabBtn);
    }
  });

  // default init state
  function initSwatchViews() {
    document.querySelectorAll('[data-swatch-view-toggle]').forEach((toggleContainer) => {
      const activeBtn =
        toggleContainer.querySelector('.product-swatch__view-option--active') ||
        toggleContainer.querySelector('[data-swatch-view]');
      if (activeBtn) handleViewToggle(activeBtn);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSwatchViews);
  } else {
    initSwatchViews();
  }

  // Re-init after Section Rendering API swaps in new markup
  document.addEventListener('shopify:section:load', initSwatchViews);

})();